import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Button from "@components/button";
import Fields from "@components/fields";
import Row from "@components/row";
import Typography from "@components/typography";
import Wrapper from "@components/wrapper";
import generalSettings from "@apis/generalSettings";
import { toast } from "react-toastify";

const StoreSetting = () => {
  const [exist, setExist] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({
    mwStatus: false,
    mwAmount: "",
    fdStatus: false,
    fdAmount: "",
  });

  // Fetch existing store settings
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await generalSettings.getByKey({
          state: "store",
          id: "store-setting",
        });

        if (res) {
          setInitialValues({
            mwStatus: res?.infos?.minimumWithdraw?.status ?? false,
            mwAmount: res?.infos?.minimumWithdraw?.amount ?? "",
            fdStatus: res?.infos?.freeDelivery?.status ?? false,
            fdAmount: res?.infos?.freeDelivery?.amount ?? "",
          });
        }
        setExist(res);
      } catch (err) {
        console.error(err);
        toast.error("Failed to fetch store settings");
      }
    };
    fetchSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    setLoading(true);

    const payload = {
      key: "store-setting",
      group: "storesettings",

      infos: {
        minimumWithdraw: {
          amount: values.mwAmount,
          status: values.mwStatus,
        },
        freeDelivery: {
          amount: values.fdAmount,
          status: values.fdStatus,
        },
      },
    };

    try {
      if (exist?.id) {
        await generalSettings.update({
          state: "store",
          id: exist.id,
          data: payload,
        });
        toast.success("Store settings updated successfully!");
      } else {
        await generalSettings.create({
          state: "store",
          data: payload,
        });
        toast.success("Store settings created successfully!");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to save store settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="Store Setting" />
          <Wrapper>
            <Row>
              <div style={{ flex: 1 }}>
                <Row styleRow="justify-content:space-between">
                  <Typography>Minimum Amount for withdrawal</Typography>
                  <Fields.Switch
                    name="mwStatus"
                    styleWrapper="width:fit-content"
                    onChange={(val) => setFieldValue("mwStatus", val)}
                  />
                </Row>
                <br />
                <Fields.Input
                  name="mwAmount"
                  placeholder="Rs 500"
                  disabled={!values.mwStatus}
                />
              </div>

              <div style={{ flex: 1 }}>
                <Row styleRow="justify-content:space-between">
                  <Typography>
                    Free Delivery Order (Rs) Store Will Pay
                  </Typography>
                  <Fields.Switch
                    name="fdStatus"
                    styleWrapper="width:fit-content"
                    onChange={(val) => setFieldValue("fdStatus", val)}
                  />
                </Row>
                <br />
                <Fields.Input
                  name="fdAmount"
                  placeholder="Rs 500"
                  disabled={!values.fdStatus}
                />
              </div>
            </Row>
            <br />
            <Button
              type="submit"
              title={exist ? "Update" : "Save"}
              justify="end"
              loading={loading}
            />
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default StoreSetting;
